module.exports = __webpack_public_path__ + "static/media/trophy.d21a4e13.svg";